import { SortOrder } from "../sort-order";

export class DefaultEncoderFilters {
  name: string;
  sortField: string;
  sortOrder: SortOrder;
}
